import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './config/api'; // 載入 API 配置，自動覆蓋 fetch
import './i18n'; // Initialize i18n

// Suppress ResizeObserver warnings (common in React Flow)
const resizeObserverErr = window.console.error;
window.console.error = (...args) => {
  if (
    typeof args[0] === 'string' &&
    args[0].includes('ResizeObserver loop')
  ) {
    return;
  }
  resizeObserverErr(...args);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);